import { createContext, useContext, useReducer, type Dispatch, type ReactNode } from 'react';
import { gameReducer, initialState, type GameAction } from './gameReducer';
import type { AppState } from '../types/game';

interface GameContextValue {
  state: AppState;
  dispatch: Dispatch<GameAction>;
}

const GameContext = createContext<GameContextValue | null>(null);

export function GameProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(gameReducer, initialState);
  return (
    <GameContext.Provider value={{ state, dispatch }}>
      {children}
    </GameContext.Provider>
  );
}

export function useGame() {
  const context = useContext(GameContext);
  if (!context) throw new Error('useGame must be used within GameProvider');
  return context;
}
